import React from 'react';
import Loader from './Loader';
import { ConvertirSaltosDeLinea } from '../utils/TextUtils';

function Leccion({ leccion, lecciones, onChangeLeccion, onCompleteLeccion, progreso }) {
  const leccionCompletada = progreso.includes(leccion?.id);

  const handleAnterior = () => {
    const indexActual = lecciones.findIndex((l) => l.id === leccion.id);
    if (indexActual > 0) {
      onChangeLeccion(lecciones[indexActual - 1]);
    }
  };

  const handleSiguiente = () => {
    const indexActual = lecciones.findIndex((l) => l.id === leccion.id);
    if (indexActual < lecciones.length - 1) {
      const siguienteLeccion = lecciones[indexActual + 1];

      // Actualizar el progreso
      onCompleteLeccion(leccion.id);

      // Cambiar a la siguiente lección
      onChangeLeccion(siguienteLeccion);
    } else {
      // Marcar lección como completada
      onCompleteLeccion(leccion.id);

      // Desplazarse al final de la página después de medio segundo
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        });
      }, 500);
    }
  };

  const indexActual = lecciones.findIndex((l) => l.id === leccion.id);

  return (
    <>
      {!leccion ? (
        <Loader />
      ) : (
        <div className='leccion-contenedor'>
          <div className='multimedia'>
            {leccion?.archivo?.tipo === 'video' && (
              <video
                src={leccion.archivo.url}
                controls
                title="Video"
                preload="auto"
                onEnded={() => onCompleteLeccion(leccion?.id)}
              >
                Tu navegador no soporta la etiqueta de video.
              </video>
            )}
            {leccion?.archivo?.tipo === 'imagen' && (
              <img
                src={leccion?.archivo?.url}
                alt="Imagen"
              />
            )}
          </div>

          <div className='contenedor'>
            <div className='separador-vertical'>
              <div className='auteco_separador-vertical'></div>
            </div>

            <div className='textos'>
              <div className='titulo'>{leccion?.titulo}</div>
              <div className='separador-horizontal'>
                <div className='auteco_separador-horizontal'></div>
              </div>
              <div className="texto">{ConvertirSaltosDeLinea(leccion?.descripcion)}</div>
            </div>
          </div>

          <div className='botones'>
            <button
              className='auteco_button primary'
              onClick={handleAnterior}
              disabled={indexActual === 0}
            >
              Anterior capítulo
            </button>

            <button
              className='auteco_button primary'
              onClick={handleSiguiente}
              disabled={!leccionCompletada && (leccion?.archivo?.tipo === 'video')}
            >
              {indexActual === lecciones.length - 1 ? 'Terminar' : 'Siguiente capítulo'}
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Leccion;
